/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Coach_Live_BackInputs */

const en_us2_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Now: ${i?.label}. Back to the workout`)
};

const pt_br2_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agora: ${i?.label}. Voltar ao treino`)
};

const es_419_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ahora: ${i?.label}. Volver al entrenamiento`)
};

const pt_pt2_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agora: ${i?.label}. Voltar ao treino`)
};

const fr_fr2_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En cours : ${i?.label}. Retour à la séance`)
};

const de_de2_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jetzt: ${i?.label}. Zurück zum Training`)
};

const it_it2_coach_live_back = /** @type {(inputs: Coach_Live_BackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ora: ${i?.label}. Torna all'allenamento`)
};

/**
* | output |
* | --- |
* | "Now: {label}. Back to the workout" |
*
* @param {Coach_Live_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_live_back = /** @type {((inputs: Coach_Live_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Live_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_live_back(inputs)
	if (locale === "es-419") return es_419_coach_live_back(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_live_back(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_live_back(inputs)
	if (locale === "de-DE") return de_de2_coach_live_back(inputs)
	if (locale === "it-IT") return it_it2_coach_live_back(inputs)
	return en_us2_coach_live_back(inputs)
});
export { coach_live_back as "coach.live_back" }